<template>
	<div class="cms-icon-block">
		<div class="cms-icon-block__shape" :style="shapeStyle">
			<i :class="'fa fa-' + icon" class="cms-icon-block__icon" :style="iconStyle"></i>
		</div>
		<div v-if="label" class="cms-icon-block__label" :style="labelStyle">{{ label }}</div>
	</div>
</template>

<script>
/**
 * IconBlock.vue
 * ─────────────
 * A standalone graphic icon with an optional background shape (circle, square,
 * rounded-square, or none) and customisable colours and size.
 *
 * Alignment, padding and visibility are wrapper traits — the root is an
 * inline-flex column so the wrapper's text-align positions it.
 */

export default {
	name: 'IconBlock',

	props: {
		/** Font Awesome icon name (without the fa- prefix) */
		icon: { type: String, default: 'star' },

		/** Shape that wraps the icon */
		shape: {
			type: String,
			default: 'circle',
			validator: function (v) { return ['circle', 'square', 'rounded', 'none'].indexOf(v) !== -1; }
		},

		/** Size of the shape container (CSS value) */
		shapeSize:      { type: String, default: '80px' },

		/** Icon size as a CSS font-size value */
		iconSize:       { type: String, default: '2rem' },

		/** Icon colour */
		iconColor:      { type: String, default: '#FFFFFF' },

		/** Background colour of the shape */
		backgroundColor: { type: String, default: '#FB6A00' },

		/** Optional label shown below the icon */
		label:      { type: String, default: '' },
		labelColor: { type: String, default: '#1E2031' },
		labelSize:  { type: String, default: '1em' }
	},

	computed: {
		shapeStyle: function () {
			var borderRadius = '0';
			if (this.shape === 'circle')  borderRadius = '50%';
			if (this.shape === 'rounded') borderRadius = '16px';

			var style = {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				width: this.shape !== 'none' ? this.shapeSize : 'auto',
				height: this.shape !== 'none' ? this.shapeSize : 'auto',
				backgroundColor: this.shape !== 'none' ? this.backgroundColor : 'transparent',
				borderRadius: borderRadius
			};
			return style;
		},

		iconStyle: function () {
			return {
				fontSize: this.iconSize,
				color: this.shape !== 'none' ? this.iconColor : this.backgroundColor,
				lineHeight: '1'
			};
		},

		labelStyle: function () {
			return {
				color: this.labelColor,
				fontSize: this.labelSize,
				fontWeight: '600'
			};
		}
	}
};
</script>

<style scoped>
.cms-icon-block {
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
	max-width: 100%;
	vertical-align: middle;
	text-align: center;
}

.cms-icon-block__shape {
	transition: transform 0.2s;
}

.cms-icon-block__label {
	margin-top: 0.25rem;
}
</style>
